import React, { useState } from 'react'
import styles from './Sidebar.module.css'
import BlogLinks from 'app/theme/BlogLinks'
import BrandPromotions from 'app/theme/banners/BrandPromotions'
import StartFoodTruck from 'app/theme/banners/StartFoodTruck'

export default function Sidebar(props) {
  const { city, region, tag, className } = props

  return (
    <div className={['grid gap-10', className]}>
      <Intro city={city} tag={tag} region={region} />
      <SearchBox />
      <div className="grid gap-5">
        <BrandPromotions />
        <StartFoodTruck />
      </div>
      <BlogLinks />
    </div>
  )
}

function Intro({ city, region, tag }) {
  let url

  if (city) {
    url = tag ? `/catering/${city.url_slug}/${tag.slug}/` : `/${city.slug}/food-truck-catering/`
  } else if (region) {
    url = `/${region.slug}/food-truck-catering/`
  } else {
    url = '/food-truck-catering/'
  }

  return (
    <div>
      <h2 className={styles.heading}>
        <a href="/food-truck-catering/">Need Food Truck Catering?</a>
      </h2>
      <p className="font-light mb-4">
        Food truck catering for your next event. Protected by <span />
        <a
          href="/food-truck-catering/roaming-hunger-guarantee/"
          className="text-blue"
          children="The 100% Roaming Hunger Guarantee"
        />
        . Fast, easy and delicious. Book it here.
      </p>
      <a
        href={url}
        className="btn btn-blue px-4 py-2 text-xl mr-1"
      >
        Get Started
      </a>
    </div>
  )
}

function SearchBox() {
  const [term, setTerm] = useState()

  return (
    <form
      className=""
      onSubmit={event => {
        event.preventDefault()
        if (term) {
          const search = window.encodeURIComponent(term)
          window.location.href = `/food-trucks/search/${search}`
        }
      }}
    >
      <h2 className={styles.heading}>
        Search Food Trucks
      </h2>
      <div className="flex">
        <input
          type="text"
          className="border border-r-0 border-gray-400 flex-1 px-3 py-2 focus:outline-none focus:border-blue"
          onChange={event => {
            setTerm(event.target.value)
          }}
        />
        <button
          type="submit"
          className="btn btn-blue px-4 py-2 text-xl"
          children="Search"
        />
      </div>
    </form>
  )
}
